import { render, staticRenderFns } from "./StackedIasProjectsInput.vue?vue&type=template&id=78ad81ce&scoped=true&"
import script from "./StackedIasProjectsInput.vue?vue&type=script&lang=js&"
export * from "./StackedIasProjectsInput.vue?vue&type=script&lang=js&"
import style0 from "./StackedIasProjectsInput.vue?vue&type=style&index=0&id=78ad81ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78ad81ce",
  null
  
)

export default component.exports